var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('div',{attrs:{"id":"loader-bg"}},[_c('div',{attrs:{"id":"loader"}},[_c('img',{attrs:{"src":"/static/images/ajax-loader.gif"}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.messages)}})])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }